module.exports = __webpack_public_path__ + "img/sdmweb.3fe1bd0d.jpeg";